import React, { useState, useEffect, useContext } from "react";
import "./MobileNav.css";
import { RootContext } from "../../RootContextProvider";

import { Menu } from "antd";
import { Link, withRouter } from "react-router-dom";
import "./button.scss";
import {
  LineChartOutlined,
  BgColorsOutlined,
  LinkOutlined,
  SettingOutlined,
} from "@ant-design/icons";

const MobileNav = ({ location, history, logout }) => {
  const { account, listPages } = useContext(RootContext);

  const [selectedKey, setSelectedKey] = useState();
  const [, setMoreOpen] = useState(false);

  useEffect(() => {
    const defineDefaultKey = async () => {
      let selectKey = await defineSelectedkey();
      setSelectedKey(selectKey);
    };
    defineDefaultKey();
    history.listen(async () => {
      setMoreOpen(false);
      let selectKey = await defineSelectedkey();
      if (selectKey) {
        setSelectedKey(selectKey);
      }
    });
    // eslint-disable-next-line
  }, [history]);

  const defineSelectedkey = async () => {
    const menu = [
      "/links",
      "/appearance",
      "/analytics",
      "/settings",
      "/admin",
      "/welcome",
      "/new-page",
    ];
    for (const m of menu) {
      if (window.location.pathname.startsWith(m)) {
        return m;
      }
    }
  };

  return (
    <div className="bottom-nav-mobile">
      {listPages && listPages.length > 0 ? (
        <>
          <Menu
            mode="horizontal"
            theme="light"
            defaultSelectedKeys={[selectedKey]}
            selectedKeys={selectedKey}
            style={{ fontSize: "20px" }}
          >
            <Menu.Item key="/links">
              <Link to="/links">
                <LinkOutlined />
              </Link>
            </Menu.Item>
            <Menu.Item key="/appearance">
              <Link to="/appearance">
                <BgColorsOutlined />
              </Link>
            </Menu.Item>

            <Menu.Item key="/analytics">
              <Link to="/analytics">
                <LineChartOutlined />
              </Link>
            </Menu.Item>
            <Menu.Item key="/settings">
              <Link to="/settings">
                <SettingOutlined />
              </Link>
            </Menu.Item>
          </Menu>
        </>
      ) : account.HasCompletedOnboarding ? (
        <Menu defaultSelectedKeys={[selectedKey]} selectedKeys={selectedKey}>
          <Menu.Item key="/new-page" icon={<LinkOutlined />}>
            <Link to="/new-page">Nouvelle page</Link>
          </Menu.Item>
        </Menu>
      ) : (
        <Menu defaultSelectedKeys={[selectedKey]} selectedKeys={selectedKey}>
          <Menu.Item key="/welcome" icon={<LinkOutlined />}>
            <Link to="/welcome">Bienvenue</Link>
          </Menu.Item>
        </Menu>
      )}
    </div>
  );
};

export default withRouter(MobileNav);
